import * as Html from "../../util/Html.ts";
import Icons from "../../svg/Icons.ts";

Html.registerWidget('widget/form/checkbox',{initDom:initDom})

export function initDom(elem: HTMLElement){

  const input = elem.querySelector('input') as HTMLInputElement;
  if(!input) return;

  const isRadio = elem.getAttribute('data-type') === 'radio';
  const icons = elem.querySelectorAll('icon');
  const icon = icons[icons.length - 1] as HTMLElement;
  if(!icon) return;

  const updater = function(){
    icon.innerHTML = input.checked ? Icons.ic_checked.toString() : Icons.ic_checkbox.toString();
  }

  if(input.disabled){
    icon.style.color = "#ccc";
  }else{
    elem.style.cursor = "pointer";
  }
  updater();

  input.addEventListener('blur', updater);

  elem.addEventListener('click', function(){
    if(input.disabled){
      return;
    }
    if(isRadio){
      // Pour les radios, décocher tous les autres du même groupe
      const form = input.closest('form');
      if(form){
        const radios = form.querySelectorAll(`input[name="${input.name}"]`) as NodeListOf<HTMLInputElement>;
        radios.forEach(radio => {
          radio.checked = false;
          radio.dispatchEvent(new Event('blur'));
        });
      }
      input.checked = true;
      input.dispatchEvent(new Event('blur'));
    }else{
      // Pour les checkboxes, inverser l'état
      const newval = !input.checked;
      input.checked = newval;
      input.dispatchEvent(new Event('blur'));
    }
  });
}
